import React from 'react';
import { MapPin } from 'react-feather';
import { useTranslation } from 'react-i18next';

interface StatewideServiceBannerProps {
  practiceAreaTitle: string;
}

const StatewideServiceBanner: React.FC<StatewideServiceBannerProps> = ({ practiceAreaTitle }) => {
  const { t } = useTranslation('common');
  return (
    <div className="py-16">
      <div className="mx-auto max-w-7xl px-6">
        <div className="p-8 md:p-12 rounded-2xl border border-white/10 bg-white/5 glass-effect flex flex-col md:flex-row items-center gap-8 text-center md:text-left">
          <div className="flex-shrink-0 w-20 h-20 rounded-full gold-gradient-bg flex items-center justify-center text-black">
            <MapPin size={40} />
          </div>
          <div>
            <h3 className="text-3xl font-bold font-serif">{t('statewideBanner.title')}</h3>
            <p className="mt-4 text-white/80 leading-relaxed">
              {t('statewideBanner.paragraph', { practiceAreaTitle })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatewideServiceBanner;